import createIcon from '../../createIcon';

/**
 * @component @name StarBorderPurple500
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgOC44OUwxMi45NCAxMkgxNS43NkwxMy40OSAxMy42MkwxNC40MiAxNi42M0wxMiAxNC43OUw5LjU4IDE2LjYzTDEwLjUxIDEzLjYyTDguMjQgMTJIMTEuMDZMMTIgOC44OVpNMTIgMkw5LjU4IDEwSDJMOC4xNyAxNC40MUw1LjgzIDIyTDEyIDE3LjMxTDE4LjE4IDIyTDE1LjgzIDE0LjQxTDIyIDEwSDE0LjQyTDEyIDJaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const StarBorderPurple500 = createIcon('StarBorderPurple500', [
  [
    'path',
    {
      d: 'M12 8.89L12.94 12H15.76L13.49 13.62L14.42 16.63L12 14.79L9.58 16.63L10.51 13.62L8.24 12H11.06L12 8.89ZM12 2L9.58 10H2L8.17 14.41L5.83 22L12 17.31L18.18 22L15.83 14.41L22 10H14.42L12 2Z',
      key: '14l83a',
    },
  ],
]);

export default StarBorderPurple500;
